import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202511: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202511",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-11-01",
  endDate: "2025-11-30",
  impressions: 61006,
  clicks: 1242,
  adsSpendDollars: 2780,
  budgetDollars: 3200,
  salesDollars: 8505,
  bestEstimateRoas: 3.06,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.87,
  newCustomersAcquired: 20,
  reorderConversions: 3,
  dataAvailableAtDate: "2025-12-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
